
//<a href="http://embed.ly" class="embedly-card">Embedly</a>

var embedlyKey = "e66e2b9e63ca4463b1be26175923286e";

function generateEmbedlyCardLink(url,target) {
    var $link = $('<a class="embedly-card button button--primary button--full"><i class="icon-cloud" aria-hidden="true"></i> Embedded Link</a>');
    $link.attr('href',url).attr('data-card-key',embedlyKey).attr('data-card-recommend','0').attr('data-card-controls','0');
    $(target).append($link);
    embedly('card', $link[0]);
}
